import SurveyValue from './SurveyValue'

class Weight extends SurveyValue {
  toSummaryLabel() {
    return `${this.toKey()} lbs.`
  }

  static keyToObject(key) {
    return new Weight(key)
  }
}

export default Weight
